import { gql } from '@apollo/client';

const BASIC_COURSE_DETAILS = gql`
  fragment BasicCourseDetails on Courses {
    id
    openedxCourseId
    inviteOnly
    subscriptionOnly
    published
  }
`;

const BASIC_COURSE_MODE_PRICE = gql`
  fragment BasicCourseModePrice on CourseModesCoursemode {
    modeSlug
    minPrice
    modeDisplayName
    currency
  }
`;

const OPENEDX_COURSE_DETAILS = gql`
  fragment OpenedxCourseDetails on CourseOverviewsCourseoverview {
    id
    displayName
    displayNumberWithDefault
    courseImageUrl
    effort
    shortDescription
    start
    endDate
    enrollmentStart
    enrollmentEnd
  }
`;

export const GET_DISCOVER_COURSES = gql`
  query GetDiscoverCourses($userId: Int4!) {
    discoverCourses: courses(
      where: {
        published: { _eq: "true" }
        _not: { courseEnrollments: { userId: { _eq: $userId } } }
      }
    ) {
      ...BasicCourseDetails
      courseTags {
        tag
      }
      details: _CourseOverviewsCourseoverview {
        ...OpenedxCourseDetails
      }
      modes: _CourseModesCoursemode(order_by: { minPrice: Asc }) {
        ...BasicCourseModePrice
      }
      modeDetails: upsellCourseModes {
        courseMode
        description
        visible
      }
    }
  }
  ${BASIC_COURSE_DETAILS}
  ${OPENEDX_COURSE_DETAILS}
  ${BASIC_COURSE_MODE_PRICE}
`;
